import { SummaryViewResponseAPI } from '@/types/summaryView';

export const FETCH_ORG_SUMMARY_VIEW_SUCCESS = 'FETCH_ORG_SUMMARY_VIEW_SUCCESS';

export interface OrgSummaryViewResponse {
    requestId: string;
    summaryView: SummaryViewResponseAPI;
}

export interface FetchOrgSummaryViewSuccessAction {
    type: typeof FETCH_ORG_SUMMARY_VIEW_SUCCESS;
    payload: OrgSummaryViewResponse;
}

export const fetchOrgSummaryViewSuccess: (payload: OrgSummaryViewResponse) => FetchOrgSummaryViewSuccessAction = (
    payload,
) => {
    return {
        type: FETCH_ORG_SUMMARY_VIEW_SUCCESS,
        payload,
    };
};
